import { Avatar } from '../components/avatar'
import { Button } from '../components/button'
import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { AuthLayout } from '../components/auth-layout'
import { Checkbox, CheckboxField } from '../components/checkbox'
import { Field, Label } from '../components/fieldset'
import { Heading } from '../components/heading'
import { Input } from '../components/input'
import { Strong, Text, TextLink } from '../components/text'
import sumoLogo from '../images/sumo_logo.png'
import config from '../config.js'
import { Loader } from '../components/loader'
import { useAlert } from "../components/customAlert";
import ValidationErrors from "../components/validationErrors";

export default function Login() {
    const { showAlert } = useAlert();
    const [formData, setFormData] = useState({ email: '', password: '', remember: false });
    const [errors, setErrors] = useState({});
    const [serverError, setServerError] = useState('');
    const [isChecking, setIsChecking] = useState(true);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
      const checkSession = async () => {
        try {
          const response = await fetch(`${config.apiPath}validate-session/check-session.php`, { method: 'GET',credentials: 'include' });
          const list_res = await response.json();
          if (list_res.loggedIn) {
            window.location.href = `/${config.appPath}dashboard`;
          }
          else {
            setIsChecking(false); // no session, show AuthLayout
          }
        }
        catch (error) {
          console.error("Session check failed:", error);
          navigate('/');
          }
      };
      checkSession();
    }, [navigate]);
     if (isChecking) return null;

    const validate = () => {
        const newErrors = {};

        if (!formData.email) {
        newErrors.email = 'Email is required';
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
        newErrors.email = 'Email format is invalid';
        }

        if (!formData.password) {
        newErrors.password = 'Password is required';
        } else if (formData.password.length < 6) {
        newErrors.password = 'Password must be at least 6 characters';
        }

        setErrors(newErrors);        
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        //setErrors(prev => ({ ...prev, [name]: '' }));
        setServerError('');
    };

    
    const handleSubmit = async (e) => {
        e.preventDefault(); // prevent page reload
        if (!validate()) return;
         try {
            setLoading(true);
            const response = await fetch(`${config.apiPath}check-login.php`, {
                method: 'POST',
				        credentials: 'include',
                headers: {
                'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            const result = await response.json();
            console.log('Server response:', result);
            if (result.status === 'success') {
                //navigate('/dashboard');
                window.location.href = `/${config.appPath}dashboard`;
            } else {
                //setServerError(result.message || 'Login failed.');
                showAlert(result.message, "Error" , "error",3000);
            }
            setLoading(false);
        } catch (err) {
            //setServerError('Server error. Please try again later.');
            //console.error('Error:', err);
            showAlert('Server error. Please try again later.', "Error" , "error",3000);
            setLoading(false);
        }
    };
    return (
    <AuthLayout>
      <form onSubmit={handleSubmit} className="grid w-full max-w-sm grid-cols-1 gap-8" noValidate>
        <Avatar src={sumoLogo} className="size-15 mx-auto" square alt="" />
        <Heading>Sign in to your account</Heading>

        {Object.values(errors).length > 0 && (
                  <ValidationErrors 
                    title="There were some errors with your submission" 
                    errors={Object.values(errors)} 
                  />
        )}

        <Field>
          <Label>Email</Label>
          <Input type="email" name="email" value={formData.email} onChange={handleChange} className={`${
            errors.email ? 'border-red-500 border-1 rounded-lg' : 'border-gray-300'}`}/>
            {/*errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>*/}
        </Field>
        <Field>
          <Label>Password</Label>
          <Input type="password" name="password"  value={formData.password} onChange={handleChange} className={`${
            errors.password ? 'border-red-500 border-1 rounded-lg' : 'border-gray-300'}`} />
          {/*errors.password && <p className="text-red-500 text-sm mt-1">{errors.password}</p>*/}
        </Field>
        <div className="flex items-center justify-between">
          <CheckboxField >
            <Checkbox name="remember"
            checked={formData.remember || false}
              onChange={(checked) =>
                setFormData((prev) => ({ ...prev, remember: checked }))
              }
            />
            <Label>Remember me</Label>
          </CheckboxField>
          <Text>
            <TextLink href="forgot-password">
              <Strong>Forgot password?</Strong>
            </TextLink>
          </Text>
        </div>
        {serverError && <p className="text-red-600 text-sm">{serverError}</p>}
        <Button type="submit" className="w-full cursor-pointer">
          Login
        </Button>
        <Text>
          Don’t have an account?{' '}
          <TextLink href="account-setup">
            <Strong>Sign up</Strong>
          </TextLink>
        </Text>
      </form>
      {loading && (
        <Loader />
      )}
    </AuthLayout>
  )
}